import { Tabs, Input, Space, Menu, Select, Col, Row, Carousel } from 'antd';
import React, { useState, useEffect, useContext, useMemo, useRef } from 'react';
import '../../styles/Filters.css';
import Comportamientos from './DefinicionDeLaAudiencia/Comportamientos'
import Ubicaciones from './DefinicionDeLaAudiencia/Ubicaciones'
import Demograficos from './FiltrarAudiencia/Demograficos'
import Dispositivos from './FiltrarAudiencia/Dispositivos'
import DateNavigation from './FiltrarAudiencia/DateNavigation'
import DataBaseExternal from './FiltrarAudiencia/DataBaseExternal'
import UserProfile from './FiltrarAudiencia/UserProfile/UserProfile';
import { UserContext } from '../../GestorContext'
import { iconUsers, iconFilters } from '../../Helpers/Icons'
import ResponsiveVisibility  from '../common/ResponsiveVisibility'
const { Option } = Select;

const Filters = (
  {
    filters,
    setFilters,
    comportamientos,
    setComportamientos,
    ubicaciones,
    setUbicaciones,
    genero,
    setGenero,
    ingreso,
    setIngreso,
    edad,
    setEdad,
    marca,
    setMarca,
    tipo,
    setTipo,
    sistemaOperativo,
    setSistemaOperativo,
    tipoSuscripcion,
    setTipoSuscripcion,
    mercado,   
    setMercado,
    servicio,
    setServicio,
    aplicacion,
    setAplicacion,
    gama,
    setGama,
    dateNavigationRange,
    hourNavigationRange,
    setDateNavigationRange,
    setHourNavigationRange,
    dataBaseExternal,
    setDataBaseExternal,
    setDBExternalName
  }
) => {
  const [view, setView] = useState('Comportamientos')
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);
  const carouselRef = useRef(null);

  const [filterRestriction, setFilterRestriction] = useState()
  useEffect(() => {
    const handleResize = () => {
      setIsVisible(window.innerWidth >= 1080);
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Check initial size

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  

  const userContext = useContext(UserContext)

  useMemo(() => {
    if (userContext) {
      const restrictions = userContext.signInUserSession.idToken.payload['custom:hour'];
      setFilterRestriction(restrictions || "Sin restricciones");
    }
  }, [userContext]);

  return (
    <> 
      <Row className="Columnas1">
        <Col span={12}>
          {iconFilters}
          <span className="SubtituloRegularGA">Filtrar Audiencia</span>
        </Col>
      </Row>
      <Row className="Columnas2">
      <ResponsiveVisibility maxWidth={1080}>
      <Row 
        style={{
          display: 'flex',
          flexWrap: 'nowrap',
          overflowX: 'auto',
          gap: '15px',
          padding: '0 0px'
        }}
      >
        {[
          'Comportamientos',
          'Apps',
          'Servicios',
          'Ubicaciones',
          'Demograficos',
          'Dispositivos',
          'Usuario',
          filterRestriction === "Enabled" && 'DateNavigation',
          'DataBaseExternal'
        ].map((tab, index) => (
          tab && (
            <div 
              key={index}
              style={{
                flex: '0 0 auto',
                minWidth: 'max-content',
                maxWidth: tab === 'DateNavigation' ? '90px' : '80px'
              }}
            >
              <div
                className={view === tab ? "ant-tabs-tab ant-tabs-tab-active" : "ant-tabs-tab"}
                onClick={() => setView(tab)}
                style={{
                  padding: '6px 8px',
                  whiteSpace: 'normal',
                  textAlign: 'center',
                  lineHeight: '1.2',
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <div
                  role="tab"
                  aria-selected={view === tab}
                  className="ant-tabs-tab-btn"
                  tabIndex="0"
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    minHeight: '20px'
                  }}
                >
                  {tab === 'DateNavigation' ? (
                    <>
                      Fecha de<br/>navegación
                    </>
                  ) : tab === 'Usuario' ? (
                    <>
                      Perfil<br/>usuario
                    </>
                  ) : tab === 'DataBaseExternal' ? (
                    <>
                      Bd<br/>externa
                    </>
                  ) : (
                    tab
                  )}
                </div>
              </div>
            </div>
          )
        ))}
      </Row>

        </ResponsiveVisibility>     
        <Col xs={24} sm={1065} hidden={isVisible}>
          <Select defaultValue={view} onChange={setView} style={{ width: '30%' }}>
            <Option value="Comportamientos">Comportamientos</Option>
            <Option value="Apps">Aplicaciones</Option>
            <Option value="Servicios">Servicios</Option>
            <Option value="Ubicaciones">Ubicaciones</Option>
            <Option value="Demograficos">Demograficos</Option>
            <Option value="Dispositivos">Dispositivos</Option>
            <Option value="Usuario">Perfil usuario</Option>
            {filterRestriction == "Enabled" && <Option value="DateNavigation">Fecha de Navegación</Option>}
            <Option value="DataBaseExternal">BD externa</Option>
          </Select>
        </Col>
        
      </Row>
      
      <div className="ant-tabs-content-holder" style={view == 'Comportamientos' ? { display: 'block' } : { display: 'none' }}>
        <Comportamientos
          filters={filters}
          setFilters={setFilters}
          typeFilter={comportamientos}
          setTypeFilter={setComportamientos}
          querieCat={"getBehaviorCat"}  
          nameFilter={"comportamiento"}
        />
      </div>
      <div className="ant-tabs-content-holder" style={view == 'Apps' ? { display: 'block' } : { display: 'none' }}>
        <Comportamientos
          filters={filters}
          setFilters={setFilters}
          typeFilter={aplicacion}
          setTypeFilter={setAplicacion}
          querieCat={"getApplicationCat"}
          nameFilter={"aplicacion"}
        />
      </div>
      <div className="ant-tabs-content-holder" style={view == 'Servicios' ? { display: 'block' } : { display: 'none' }}>
        <Comportamientos
          filters={filters}
          setFilters={setFilters}
          typeFilter={servicio}
          setTypeFilter={setServicio}
          querieCat={"getServiceCat"}
          nameFilter={"servicio"}
        />
      </div>
      <div className="ant-tabs-content-holder" style={view == 'Ubicaciones' ? { display: 'block' } : { display: 'none' }}>
        <Ubicaciones
          filters={filters}
          setFilters={setFilters}
          ubicaciones={ubicaciones}
          setUbicaciones={setUbicaciones}
        />
      </div>
      <div className="ant-tabs-content-holder" style={view == 'Demograficos' ? { display: 'block' } : { display: 'none' }}>
        <Demograficos
          filters={filters}
          setFilters={setFilters}
          genero={genero}
          setGenero={setGenero}
          ingreso={ingreso}
          setIngreso={setIngreso}
          edad={edad}
          setEdad={setEdad}
        />
      </div>
      <div className="ant-tabs-content-holder" style={view == 'Dispositivos' ? { display: 'block' } : { display: 'none' }}>
        <Dispositivos
          filters={filters}
          setFilters={setFilters}
          marca={marca}
          setMarca={setMarca}
          tipo={tipo}
          setTipo={setTipo}
          sistemaOperativo={sistemaOperativo}
          setSistemaOperativo={setSistemaOperativo}
          gama={gama}
          setGama={setGama}
        />
      </div>
      <div className="ant-tabs-content-holder" style={view == 'Usuario' ? { display: 'block' } : { display: 'none' }}>
        <UserProfile
          tipoSuscripcion={tipoSuscripcion}
          setTipoSuscripcion={setTipoSuscripcion}
          mercado={mercado}
          setMercado={setMercado}
        />
      </div>
      <div className="ant-tabs-content-holder" style={view == 'DateNavigation' ? { display: 'block' } : { display: 'none' }}>
        <DateNavigation
          filters={filters}
          setFilters={setFilters}
          dateNavigationRange={dateNavigationRange}
          setDateNavigationRange={setDateNavigationRange}
          hourNavigationRange={hourNavigationRange}
          setHourNavigationRange={setHourNavigationRange}
        />
      </div>
      <div className="ant-tabs-content-holder" style={view == 'DataBaseExternal' ? { display: 'block' } : { display: 'none' }}>
      <DataBaseExternal dataBaseExternal={dataBaseExternal} setDataBaseExternal={setDataBaseExternal} setDBExternalName={setDBExternalName}/>
      </div>
    </>
  );
};

export default Filters;
